import http from '@/http'

const PATH = '/customers'

function getPath (customerId) {
    return `${PATH}/${customerId}/products`
}

export default {
    /**
     * @param {{customerId: number, params: {}}} data
     * @returns {Promise<void>}
     */
    async listProducts ({customerId, params}) {
        try {
            const response = await http.get(getPath(customerId), {params})
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    },
    /**
     * @param {{customerId: number, productId: number,}} data
     * @returns {Promise<void>}
     */
    async showProduct ({customerId, productId}) {
        try {
            const response = await http.get(`${getPath(customerId)}/${productId}`)
            return response.data
        } catch (e) {
            return Promise.reject(e)
        }
    }
}
